/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import { clsx } from 'clsx';
import { ConfigContext } from '../config-provider';
import BackTop from './BackTop';
import FloatButton, { floatButtonPrefixCls } from './FloatButton';
import FloatButtonGroup from './FloatButtonGroup';
const PureFloatButton = ({ backTop, ...props }) => backTop ? React.createElement(BackTop, { ...props, visibilityHeight: 0 }) : React.createElement(FloatButton, { ...props });
/** @private Internal Component. Do not use in your production. */
const PurePanel = ({ className, items, classNames: cls, styles, prefixCls: customizePrefixCls, ...restProps }) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls(floatButtonPrefixCls, customizePrefixCls);
    const pureCls = `${prefixCls}-pure`;
    if (items) {
        return (React.createElement(FloatButtonGroup, { className: clsx(className, pureCls), classNames: cls, styles: styles, ...restProps }, items.map((item, index) => (React.createElement(PureFloatButton, { key: index, ...item })))));
    }
    return (React.createElement(PureFloatButton, { className: clsx(className, pureCls), classNames: cls, styles: styles, ...restProps }));
};
export default PurePanel;
